<template>
  <div>
    <MainForm
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :name="FORM_NAMES.insurance"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="NBC Insurance application"
   
    >
   
      <StepModel
        :ui="uiBaseNbc"
        :name="STEP_NAMES.insuranceType"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
     
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.insurance"
          ui-title="What kind of insurance plan you are looking for?"
        >
          <UiWrapper :name="FIELD_NAMES.insuranceType" >
            <Choice :columns="2" :options="INSURANCE" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

    </MainForm>
  </div>
</template>

<script>
let stepToGo = "Welcome";
// Services
import flowManager from "@/lib/services/flow-manager";
import store from "@/store";
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
import StepOtp from "@/forms/components/shared/steps/otp";
import FIELD_NAMES from "@/forms/constants/field-names";
import {
  SET_USE,
  SET_HOW_MUCH,
  SET_INSTALMENT,
  SET_OTHER,
  SET_LOAN_TYPE
} from "@/lib/constants/mutations";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldIncome from "@/forms/components/shared/fields/income";

// Ui Components
import {
  NBCSuggestions,
  InputText,
  Choice,
  InputSlide,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  PlainText,
  
} from "@dunia/ui";

// Utils
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Helpers

// Constants
import {
 INSURANCE,
  //FIELD_NAMES
} from "@/forms/constants/nbc-logic";

export default {
  name: "NBC",

  mixins: [FormComponentMixin],

  components: {
    NBCSuggestions,
    // Components
    MainForm,
    StepModel,
    FieldsetModel,
    InputText,
    Choice,
    InputSlide,
    UiWrapper,
    FieldIncome,
    Button,
    // Pages
    ProductCover,
    SidePanel,
    Grid,
    PlainText,
    StepOtp
  },

  data: () => ({
    panelVisible: -1,
  INSURANCE,
    FIELD_NAMES
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated: function() {
    store.commit(SET_USE, { use: this.fieldValues(FIELD_NAMES.use) });
    store.commit(SET_HOW_MUCH, {
      howMuch: this.fieldValues(FIELD_NAMES.howmuch)
    });
    store.commit(SET_INSTALMENT, {
      instalment: this.fieldValues(FIELD_NAMES.instalments)
    });
    store.commit(SET_OTHER, { other: this.fieldValues(FIELD_NAMES.other) });
    store.commit(SET_LOAN_TYPE, { loanType: "Personal Loan" });
  },
  computed: {
    // show if
    // - already in installments step
    // showFilters() {
    //   const sn = flowManager.currentStepName;
    //   return sn === "instalments-step" || sn === "show-cards";
    // },

    // getFilteredSuggestions() {
    //   return FEATURES_LOAN;
    // },


    // hasNBCFinished() {
    //   return flowManager.currentStepName === "show-cards";
    // },
    
  },

  methods: {
    actionWrapper(cb, ...args) {
      return () => cb(...args);
    },

    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },

    // benefits panel logic
    isPanelVisible(key) {
      return key === this.panelVisible;
    },

    showPanel(key) {
      this.panelVisible = key;
    },

    hidePanel() {
      this.panelVisible = -1;
    },

    showBest(key, label) {
      if (key === 0) {
        return label;
      }
      return null;
    },
     
   gotToProtect(callback) {
  var product = this.fieldValues(FIELD_NAMES.product);
        var formToGo = "";
        if (product) {
          if (product.toLowerCase() === "personal loan".toLowerCase()) {
            formToGo = "Deem | Loan Application";
          } else if (product.toLowerCase() === "credit card") {
            formToGo = "Deem | Credit Card Application";
          }
        }
         callback();
        if (formToGo != "") {
          router.goToFormByName(formToGo, {
            stepNameToInit: stepToGo
          });
        }
    }
  }
};
</script>
